<template>
	<div class="price">
		<h1 class="hit-html-h1">{{ $t('message.price') }}</h1>

	</div>
</template>
<script>
export default{
  name: 'price'

}
</script>

<style scoped>

</style>
